import getBlockDepth from '../../utils/getBlockDepth';
export default function isIndented(editor) {
  var block = editor.value.document.getClosestBlock(editor.value.selection.start.key);
  return getBlockDepth(block) > 0;
}